import styled from 'styled-components';
import { DropDownWithLabel } from '../../../../component/dropDown';
import { Input } from '../../../../component/input';
import { AddModal } from '../../../../component/modal';

export const CustomAddModal = styled(AddModal)`
  max-width: 430px;
`;
export const Container = styled.div`
  padding: 0px 40px;
  padding: auto;
  align-self: center;
`;
export const CustomInput = styled(Input)`
  margin-bottom: 16px;
`;
export const DropDown = styled(DropDownWithLabel)`
  margin-bottom: 16px;
`;
